// Centralized GA4 event tracking for Shopify themes/apps
// Usage: Call GA4Events.trackEvent('event_name', eventData) from anywhere

window.GA4Events = (function() {
    window.dataLayer = window.dataLayer || [];


    // Helper to push to dataLayer
    function pushEvent(eventName, eventData) {
        window.dataLayer.push({
            event: eventName,
            ...eventData
        });
    }

    // --- Validation Helpers ---
    function validateFields(obj, requiredFields, eventName) {
        let valid = true;
        requiredFields.forEach(field => {
            //console.log("field:", typeof field)
            if (typeof field === 'string') {
                //console.log("field 1:", typeof field)
                if (!(field in obj) || obj[field] === undefined || obj[field] === null || obj[field] === '') {
                    console.error(`GA4 ${eventName}: Missing required field '${field}'`, obj);
                    valid = false;
                }
            } else if (typeof field === 'object') {
               // console.log("field 2:", typeof field)
                // {name: 'field', type: 'string'}
                const { name, url, bannerName, type } = field;
                //console.log("field 3:", typeof name, typeof type)
                if (!(name in obj) || typeof obj[name] !== type || obj[name] === '' || obj[name] === undefined || obj[name] === null) {
                    console.error(`GA4 ${eventName}: Field '${name}' must be of type ${type}`, obj);
                    valid = false;
                }
            }
        });
        return valid;
    }

    function validateItems(items, eventName) {
        if (!Array.isArray(items) || items.length === 0) {
            console.error(`GA4 ${eventName}: 'items' must be a non-empty array`, items);
            return false;
        }
        let valid = true;
        items.forEach((item, idx) => {
            if (!validateFields(item, [
                { name: 'item_id', type: 'string' },
                { name: 'item_name', type: 'string' },
                { name: 'price', type: 'number' },
                { name: 'quantity', type: 'number' }
            ], `${eventName} (item[${idx}])`)) {
                valid = false;
            }
        });
        return valid;
    }
    // --- End Validation Helpers ---

    // Predefined event helpers (extend as needed)
    return {
        trackEvent: pushEvent,
        // Product List View
        viewItemList: function({ item_list_id, item_list_name, items }) {
            // if (!validateFields({ item_list_id, item_list_name }, [
            //     { name: 'item_list_id', type: 'string' },
            //     { name: 'item_list_name', type: 'string' }
            // ], 'viewItemList') || !validateItems(items, 'viewItemList')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || "NA",   
                discount: item.discount || "NA",
                index: item.index || "NA",
                item_brand: item.item_brand || "NA",
                item_category: item.item_category || "NA",
                item_category2: item.item_category2 || "NA",
                item_category3: item.item_category3 || "NA",
                item_category4: item.item_category4 || "NA",
                item_category5: item.item_category5 || "NA",
                item_list_id: item_list_id,
                item_list_name: item_list_name,
                item_variant: item.item_variant || "NA",
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('view_item_list', {
                ecommerce: {
                    item_list_id,
                    item_list_name,
                    items: formattedItems
                }
            });
        },

        // Product Click
        selectItem: function({ item_list_id, item_list_name, items }) {
            // if (!validateFields({ item_list_id, item_list_name }, [
            //     { name: 'item_list_id', type: 'string' },
            //     { name: 'item_list_name', type: 'string' }
            // ], 'selectItem') || !validateItems(items, 'selectItem')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || "NA",
                discount: item.discount || "NA",
                index: item.index || "NA",
                item_brand: item.item_brand || "NA",
                item_category: item.item_category || "NA",
                item_category2: item.item_category2 || "NA",
                item_category3: item.item_category3 || "NA",
                item_category4: item.item_category4 || "NA",
                item_category5: item.item_category5 || "NA",
                item_list_id: item_list_id,
                item_list_name: item_list_name,
                item_variant: item.item_variant || "NA",
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('select_item', {
                ecommerce: {
                    item_list_id,
                    item_list_name,
                    items: formattedItems
                }
            });
        },

        // Product Viewed
        viewItem: function({ currency, value, items }) {
            // if (!validateFields({ currency, value }, [
            //     { name: 'currency', type: 'string' },
            //     { name: 'value', type: 'number' }
            // ], 'viewItem') || !validateItems(items, 'viewItem')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || "NA",
                discount: item.discount || "NA",
                item_brand: item.item_brand || "NA",
                item_category: item.item_category || "NA",
                item_category2: item.item_category2 || "NA",
                item_category3: item.item_category3 || "NA",
                item_category4: item.item_category4 || "NA",
                item_category5: item.item_category5 || "NA",
                item_list_id: item.item_list_id || "NA",
                item_list_name: item.item_list_name || "NA",
                item_variant: item.item_variant || "NA",
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('view_item', {
                ecommerce: {
                    currency,
                    value,
                    items: formattedItems
                }
            });
        },

        // Product Added to Cart
        addToCart: function({ currency, value, items }) {
            if (!validateFields({ currency, value }, [
                { name: 'currency', type: 'string' },
                { name: 'value', type: 'number' }
            ], 'addToCart') || !validateItems(items, 'addToCart')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || "NA",
                discount: item.discount || "NA",
                item_brand: item.item_brand || "NA",
                item_category: item.item_category || "NA",
                item_category2: item.item_category2 || "NA",
                item_category3: item.item_category3 || "NA",
                item_category4: item.item_category4 || "NA",
                item_category5: item.item_category5 || "NA",
                item_list_id: item.item_list_id || "NA",
                item_list_name: item.item_list_name || "NA",
                item_variant: item.item_variant || "NA",
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('add_to_cart', {
                ecommerce: {
                    currency,
                    value,
                    items: formattedItems
                }
            });
        },

        // Cart Viewed
        viewCart: function({ currency, value, items }) {
            // if (!validateFields({ currency, value }, [
            //     { name: 'currency', type: 'string' },
            //     { name: 'value', type: 'number' }
            // ], 'viewCart') || !validateItems(items, 'viewCart')) return;
            // window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || undefined,
                discount: item.discount || undefined,
                item_brand: item.item_brand || undefined,
                item_category: item.item_category || undefined,
                item_category2: item.item_category2 || undefined,
                item_category3: item.item_category3 || undefined,
                item_category4: item.item_category4 || undefined,
                item_category5: item.item_category5 || undefined,
                item_list_id: item.item_list_id || undefined,
                item_list_name: item.item_list_name || undefined,
                item_variant: item.item_variant || undefined,
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('view_cart', {
                ecommerce: {
                    currency,
                    value,
                    items: formattedItems
                }
            });
        },

        // Product Removed from Cart
        removeFromCart: function({ currency, value, items }) {
            if (!validateFields({ currency, value }, [
                { name: 'currency', type: 'string' },
                { name: 'value', type: 'number' }
            ], 'removeFromCart') || !validateItems(items, 'removeFromCart')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || undefined,
                discount: item.discount || undefined,
                item_brand: item.item_brand || undefined,
                item_category: item.item_category || undefined,
                item_category2: item.item_category2 || undefined,
                item_category3: item.item_category3 || undefined,
                item_category4: item.item_category4 || undefined,
                item_category5: item.item_category5 || undefined,
                item_list_id: item.item_list_id || undefined,
                item_list_name: item.item_list_name || undefined,
                item_variant: item.item_variant || undefined,
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('remove_from_cart', {
                ecommerce: {
                    currency,
                    value,
                    items: formattedItems
                }
            });
        },

        // Checkout Begins
        beginCheckout: function({ coupon, currency, value, items }) {
            if (!validateFields({ currency, value }, [
                { name: 'currency', type: 'string' },
                { name: 'value', type: 'number' }
            ], 'beginCheckout') || !validateItems(items, 'beginCheckout')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || undefined,
                discount: item.discount || undefined,
                item_brand: item.item_brand || undefined,
                item_category: item.item_category || undefined,
                item_category2: item.item_category2 || undefined,
                item_category3: item.item_category3 || undefined,
                item_category4: item.item_category4 || undefined,
                item_category5: item.item_category5 || undefined,
                item_list_id: item.item_list_id || undefined,
                item_list_name: item.item_list_name || undefined,
                item_variant: item.item_variant || undefined,
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('begin_checkout', {
                ecommerce: {
                    coupon,
                    currency,
                    value,
                    items: formattedItems
                }
            });
        },

        // Purchase / Transaction
        purchase: function({ transaction_id, value, tax, shipping, currency, coupon, affiliation, items }) {
            if (!validateFields({ transaction_id, value, currency }, [
                { name: 'transaction_id', type: 'string' },
                { name: 'value', type: 'number' },
                { name: 'currency', type: 'string' }
            ], 'purchase') || !validateItems(items, 'purchase')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || undefined,
                discount: item.discount || undefined,
                item_brand: item.item_brand || undefined,
                item_category: item.item_category || undefined,
                item_category2: item.item_category2 || undefined,
                item_category3: item.item_category3 || undefined,
                item_category4: item.item_category4 || undefined,
                item_category5: item.item_category5 || undefined,
                item_list_id: item.item_list_id || undefined,
                item_list_name: item.item_list_name || undefined,
                item_variant: item.item_variant || undefined,
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('purchase', {
                ecommerce: {
                    transaction_id,
                    value,
                    tax,
                    shipping,
                    currency,
                    coupon,
                    affiliation,
                    items: formattedItems
                }
            });
        },

        // Promotion / Banner View
        viewPromotion: function({ promotion_id, promotion_name, creative_name, creative_slot, location_id, items }) {
  
  // Step 1: Validate mandatory fields
  if (!validateFields(
        { promotion_id, promotion_name }, 
        [
          { name: 'promotion_id', type: 'string' },
          { name: 'promotion_name', type: 'string' }
        ], 
        'viewPromotion'
      ) || 
      !validateItems(items, 'viewPromotion')) return;

  // Step 2: Clear any previous ecommerce data from dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });

  // Step 3: Prepare 'items' array with only allowed GA4 fields
  const formattedItems = items.map(item => ({
    item_id: item.item_id,
    item_name: item.item_name,
    coupon: item.coupon || undefined,
    discount: item.discount || undefined,
    item_brand: item.item_brand || undefined,
    item_category: item.item_category || undefined,
    item_category2: item.item_category2 || undefined,
    item_category3: item.item_category3 || undefined,
    item_category4: item.item_category4 || undefined,
    item_category5: item.item_category5 || undefined,
    item_list_id: item.item_list_id || undefined,
    item_list_name: item.item_list_name || undefined,
    item_variant: item.item_variant || undefined,
    price: item.price,
    quantity: item.quantity
  }));

  // Step 4: Push the final event to dataLayer
  pushEvent('view_promotion', {
    ecommerce: {
      promotion_id,
      promotion_name,
      creative_name,
      creative_slot,
      location_id,
      items: formattedItems
    }
  });
},


        // Promotion / Banner Click
        selectPromotion: function({ promotion_id, promotion_name, creative_name, creative_slot, location_id, items }) {
            if (!validateFields({ promotion_id, promotion_name }, [
                { name: 'promotion_id', type: 'string' },
                { name: 'promotion_name', type: 'string' }
            ], 'selectPromotion') || !validateItems(items, 'selectPromotion')) return;
            window.dataLayer.push({ ecommerce: null });
            // Ensure each item in items has the required GA4 fields
            const formattedItems = items.map(item => ({
                item_id: item.item_id,
                item_name: item.item_name,
                coupon: item.coupon || undefined,
                discount: item.discount || undefined,
                item_brand: item.item_brand || undefined,
                item_category: item.item_category || undefined,
                item_category2: item.item_category2 || undefined,
                item_category3: item.item_category3 || undefined,
                item_category4: item.item_category4 || undefined,
                item_category5: item.item_category5 || undefined,
                item_list_id: item.item_list_id || undefined,
                item_list_name: item.item_list_name || undefined,
                item_variant: item.item_variant || undefined,
                price: item.price,
                quantity: item.quantity
            }));
            pushEvent('select_promotion', {
                ecommerce: {
                    promotion_id,
                    promotion_name,
                    creative_name,
                    creative_slot,
                    location_id,
                    items: formattedItems
                }
            });
        },
        // --- Custom Events ---
        // Header Banner Click
        headerBannerClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' },
            //     { name: 'banner_title', type: 'string' }
            // ], 'headerBannerClick')) return;
            window.dataLayer.push({ event: 'header_banner_click', ...obj });
        },

        // Header Navigation
     // GA4 Header Navigation Push
        // Header Navigation
        headerNavigation: function(obj) {
          //console.log("header_navigation ><><><><");
            // if (!validateFields(obj, [
            //     { name: 'menu_name', type: 'string' },
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' },
            //     { name: 'menu_level', type: 'string' },
            //     { name: 'menu_category', type: 'string' }
            // ], 'headerNavigation')) return;
            window.dataLayer.push({ event: 'header_navigation', ...obj });
        },


        // Footer Navigation
        footerNavigation: function(obj) {
            if (!validateFields(obj, [
                { name: 'menu_name', type: 'string' },
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' },
                { name: 'menu_level', type: 'string' },
                { name: 'menu_category', type: 'string' }
            ], 'footerNavigation')) return;
            window.dataLayer.push({ event: 'footer_navigation', ...obj });
        },
        // Hamburger Navigation
       hamburgerNavigation: function(obj) {
  if (!validateFields(obj, [
    { name: 'menu_name', type: 'string' },
    { name: 'click_text', type: 'string' },
    { name: 'click_url', type: 'string' },
    { name: 'menu_level', type: 'string' },
    { name: 'menu_category', type: 'string' }
  ], 'hamburgerNavigation')) return;

  window.dataLayer.push({ event: 'hamburger_navigation', ...obj });
},

        // Breadcrumb Navigation
       breadcrumbNavigation: function(obj) {
//   if (!validateFields(obj, [
//     { name: 'menu_name', type: 'string' },
//     { name: 'click_text', type: 'string' },
//     { name: 'click_url', type: 'string' },
//     { name: 'menu_level', type: 'string' },
//     { name: 'menu_category', type: 'string' }
//   ], 'breadcrumbNavigation')) return;

  window.dataLayer.push({ event: 'breadcrumb_navigation', ...obj });

  
},

        // Shop By Category
      // Inside GA4Events object
shopByCategory: function(obj) {
    // Optional safety check
    // if (!validateFields(obj, [
    //     { name: 'click_text', type: 'string' },
    //     { name: 'click_url', type: 'string' }
    // ], 'shopByCategory')) return;

    // Push to GA4
    window.dataLayer.push({ event: 'shop_by_category', ...obj });
},

        // Shop By Concern
       shopByConcern: function(obj) {
    // if (!validateFields(obj, [
    //     { name: 'click_text', type: 'string' },
    //     { name: 'click_url', type: 'string' }
    // ], 'shopByConcern')) return;

    window.dataLayer.push({ event: 'shop_by_concern', ...obj });
},

        // Login
        login: function(obj) {
            if (!validateFields(obj, [
                { name: 'method', type: 'string' },
                { name: 'user_id', type: 'string' }
            ], 'login')) return;
            window.dataLayer.push({ event: 'login', ...obj });
        },
        // Sign Up
       sign_up: function(obj) {
  if (!validateFields(obj, [
    { name: 'method', type: 'string' },
    { name: 'user_id', type: 'string' }
  ], 'sign_up')) return;

  window.dataLayer.push({ event: 'sign_up', ...obj });

 
},

        // Social Interaction
        socialInteraction: function(obj) {
             if (!validateFields(obj, [
    { name: 'platform', type: 'string' },
    { name: 'page_section', type: 'string' }
  ], 'social_interaction')) return;

  window.dataLayer.push({
    event: 'social_interaction',
    ...obj
  });
},
        
        // Search Icon Click
    searchIconClick: function() {
  window.dataLayer.push({
    event: "search_icon_click"
  });
},



        // Popular Searches
        popularSearches: function(obj) {
            if (!validateFields(obj, [
                { name: 'search_term', type: 'string' },
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' }
            ], 'popularSearches')) return;
            window.dataLayer.push({ event: 'popular_searches', ...obj });
        },
        // Search Recently Viewed
        searchRecentlyViewed: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'search_term', type: 'string' },
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' }
            // ], 'searchRecentlyViewed')) return;
            window.dataLayer.push({ event: 'search_recently_viewed', ...obj });
        },
        // Search Products
        searchProducts: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'search_term', type: 'string' },
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' }
            // ], 'searchProducts')) return;
            window.dataLayer.push({ event: 'search_products', ...obj });
        },
        // Search Best Sellers
        searchBestSellers: function(obj) {
            if (!validateFields(obj, [
                // { name: 'search_term', type: 'string' },
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' }
            ], 'searchBestSellers')) return;
            window.dataLayer.push({ event: 'search_best_sellers', ...obj });
        },
        // View Search Results
        viewSearchResults: function(obj) {
            if (!validateFields(obj, [
                { name: 'search_term', type: 'string' }
            ], 'viewSearchResults')) return;
            window.dataLayer.push({ event: 'view_search_results', ...obj });
        },
        // Hero Banner
        heroBanner: function(obj) {
            if (!validateFields(obj, [
                { name: 'banner_title', type: 'string' },
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' }
            ], 'heroBanner')) return;
            window.dataLayer.push({ event: 'hero_banner', ...obj });
        },
        // Support Chat Open
        supportChatOpen: function() {
            window.dataLayer.push({ event: 'support_chat_open' });
        },
        // Support Chat Click
        supportChatClick: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' }
            ], 'supportChatClick')) return;
            window.dataLayer.push({ event: 'support_chat_click', ...obj });
        },
        // Product Card Swipe
        productCardSwipe: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'page_section', type: 'string' },
            //     { name: 'swipe_direction', type: 'string' },
            //     { name: 'card_position', type: 'number' },
            //     { name: 'regime_step', type: 'string' }
            // ], 'productCardSwipe')) return;
            window.dataLayer.push({ event: 'product_card_swipe', ...obj });
        },
        // Product Variant Click
        productVariantClick: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'product_title', type: 'string' }
            ], 'productVariantClick')) return;
            window.dataLayer.push({ event: 'product_variant_click', ...obj });
        },
        // Build Your Regime Step
        buildYourRegimeStep: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' }
            ], 'buildYourRegimeStep')) return;
            window.dataLayer.push({ event: 'build_your_regime_step', ...obj });
        },
        // Testimonial Swipe
        testimonialSwipe: function(obj) {
            if (!validateFields(obj, [
                { name: 'swipe_direction', type: 'string' }
            ], 'testimonialSwipe')) return;
            window.dataLayer.push({ event: 'testimonial_swipe', ...obj });
        },
        // Blog Open
        blogOpen: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'blog_title', type: 'string' }
            // ], 'blogOpen')) return;
            window.dataLayer.push({ event: 'blog_open', ...obj });
        },
        // Subscribe
        subscribe: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'hashed_email', type: 'string' }
            // ], 'subscribe')) return;
            
            window.dataLayer.push({ event: 'subscribe', ...obj });
        },

        // CP Main Banner Swipe
        cpMainBannerSwipe: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'swipe_direction', type: 'string' },
            //     { name: 'image_position', type: 'number' }
            // ], 'cpMainBannerSwipe')) return;
            window.dataLayer.push({ event: 'cp_main_banner_swipe', ...obj });
        },
        // CP Main Banner Click
        cpMainBannerClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' },
            //     { name: 'image_position', type: 'number' },
            //     { name: 'banner_title', type: 'string' }
            // ], 'cpMainBannerClick')) return;
            window.dataLayer.push({ event: 'cp_main_banner_click', ...obj });
        },
        // FAQ
        faq: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'action_type', type: 'string' }
            // ], 'faq')) return;
            window.dataLayer.push({ event: 'faq', ...obj });
        },
        // Filter Products
        filterProducts: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'filter_value', type: 'string' },
            //     { name: 'filter_type', type: 'string' },
            //     { name: 'all_filters', type: 'string' }
            // ], 'filterProducts')) return;
            window.dataLayer.push({ event: 'filter_products', ...obj });
        },
        // Sort Products
        sortProducts: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'sort_by', type: 'string' }
            // ], 'sortProducts')) return;
            window.dataLayer.push({ event: 'sort_products', ...obj });
        },
        // Load More Products
        loadMoreProducts: function() {
            window.dataLayer.push({ event: 'load_more_products' });
        },
        // Review Initiate
        reviewInitiate: function() {
            window.dataLayer.push({ event: 'review_initiate' });
        },
        // Review Submit
        reviewSubmit: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'ratings', type: 'number' }
            // ], 'reviewSubmit')) return;
            window.dataLayer.push({ event: 'review_submit', ...obj });
        },
        // Delivery Check
        deliveryCheck: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'pincode', type: 'string' },
            //     { name: 'product_title', type: 'string' }
            // ], 'deliveryCheck')) return;
            window.dataLayer.push({ event: 'delivery_check', ...obj });
        },
        // Video Start
        videoStart: function(obj) {
            if (!validateFields(obj, [
                { name: 'video_current_time', type: 'number' },
                { name: 'video_duration', type: 'number' },
                { name: 'video_percent', type: 'number' },
                { name: 'video_provider', type: 'string' },
                { name: 'video_title', type: 'string' },
                { name: 'video_url', type: 'string' }
            ], 'videoStart')) return;
            window.dataLayer.push({ event: 'video_start', ...obj });
        },
        // Video Progress
        videoProgress: function(obj) {
            if (!validateFields(obj, [
                { name: 'video_current_time', type: 'number' },
                { name: 'video_duration', type: 'number' },
                { name: 'video_percent', type: 'number' },
                { name: 'video_provider', type: 'string' },
                { name: 'video_title', type: 'string' },
                { name: 'video_url', type: 'string' }
            ], 'videoProgress')) return;
            window.dataLayer.push({ event: 'video_progress', ...obj });
        },
        // Video Complete
        videoComplete: function(obj) {
            if (!validateFields(obj, [
                { name: 'video_current_time', type: 'number' },
                { name: 'video_duration', type: 'number' },
                { name: 'video_percent', type: 'number' },
                { name: 'video_provider', type: 'string' },
                { name: 'video_title', type: 'string' },
                { name: 'video_url', type: 'string' }
            ], 'videoComplete')) return;
            window.dataLayer.push({ event: 'video_complete', ...obj });
        },
        // Podcast Start
        podcastStart: function(obj) {
            if (!validateFields(obj, [
                { name: 'podcast_current_time', type: 'number' },
                { name: 'podcast_duration', type: 'number' },
                { name: 'podcast_percent', type: 'number' },
                { name: 'podcast_title', type: 'string' },
                { name: 'podcast_url', type: 'string' }
            ], 'podcastStart')) return;
             window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'podcast_start', ...obj });
        },
        // Podcast Progress
        podcastProgress: function(obj) {
            if (!validateFields(obj, [
                { name: 'podcast_current_time', type: 'number' },
                { name: 'podcast_duration', type: 'number' },
                { name: 'podcast_percent', type: 'number' },
                { name: 'podcast_title', type: 'string' },
                { name: 'podcast_url', type: 'string' }
            ], 'podcastProgress')) return;
            window.dataLayer.push({ event: 'podcast_progress', ...obj });
        },
        // Podcast Complete
        podcastComplete: function(obj) {
            if (!validateFields(obj, [
                { name: 'podcast_current_time', type: 'number' },
                { name: 'podcast_duration', type: 'number' },
                { name: 'podcast_percent', type: 'number' },
                { name: 'podcast_title', type: 'string' },
                { name: 'podcast_url', type: 'string' }
            ], 'podcastComplete')) return;
            window.dataLayer.push({ event: 'podcast_complete', ...obj });
        },
        // Product Image Swipe
        productImageSwipe: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'swipe_direction', type: 'string' },
            //     { name: 'image_position', type: 'number' },
            //     { name: 'product_title', type: 'string' }
            // ], 'productImageSwipe')) return;
            window.dataLayer.push({ event: 'product_image_swipe', ...obj });
        },
        // Offer Copy Click
        offerCopyClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'product_title', type: 'string' }
            // ], 'offerCopyClick')) return;
            window.dataLayer.push({ event: 'offer_copy_click', ...obj });
        },
        // Review Click
        reviewClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'ratings', type: 'number' },
            //     { name: 'product_title', type: 'string' }
            // ], 'reviewClick')) return;
            window.dataLayer.push({ event: 'review_click', ...obj });
        },
        // Product Image Module Open
        productImageModuleOpen: function(obj) {
            if (!validateFields(obj, [
                { name: 'image_position', type: 'number' },
                { name: 'product_title', type: 'string' }
            ], 'productImageModuleOpen')) return;
            window.dataLayer.push({ event: 'product_image_module_open', ...obj });
        },
        // Instant Award Redeem Now
        instantAwardRedeemNow: function(obj) {
            if (!validateFields(obj, [
                { name: 'offer_text', type: 'string' }
            ], 'instantAwardRedeemNow')) return;
            window.dataLayer.push({ event: 'instant_award_redeem_now', ...obj });
        },
        // Instant Award Sign Up
        instantAwardSignUp: function(obj) {
            if (!validateFields(obj, [
                { name: 'offer_text', type: 'string' }
            ], 'instantAwardSignUp')) return;
            window.dataLayer.push({ event: 'instant_award_sign_up', ...obj });
        },
        // Earn Reward Signup
        earnRewardSignup: function(obj) {
            if (!validateFields(obj, [
                { name: 'offer_text', type: 'string' },
                { name: 'page_section', type: 'string' }
            ], 'earnRewardSignup')) return;
            window.dataLayer.push({ event: 'earn_reward_signup', ...obj });
        },
        // Earn Reward Login
        earnRewardLogin: function(obj) {
            if (!validateFields(obj, [
                { name: 'offer_text', type: 'string' },
                { name: 'page_section', type: 'string' }
            ], 'earnRewardLogin')) return;
            window.dataLayer.push({ event: 'earn_reward_login', ...obj });
        },
        // Banner Click
        bannerClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'click_url', type: 'string' },
            //     { name: 'page_section', type: 'string' },
            //     { name: 'banner_title', type: 'string' }
            // ], 'bannerClick')) return;
            window.dataLayer.push({ event: 'banner_click', ...obj });
        },
        // PDP Sticky Header Navigation
        pdpStickyHeaderNavigation: function(obj) {
            if (!validateFields(obj, [
                { name: 'menu_name', type: 'string' },
                { name: 'click_text', type: 'string' }
            ], 'pdpStickyHeaderNavigation')) return;
            window.dataLayer.push({ event: 'pdp_sticky_header_navigation', ...obj });
        },
        // PDP Scroll Up Click
        pdpScrollUpClick: function() {
            window.dataLayer.push({ event: 'pdp_scroll_up_click' });
        },
        // Shop Now
        shopNow: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' }
            ], 'shopNow')) return;
            window.dataLayer.push({ event: 'shop_now', ...obj });
        },
        // Download App Google Play
        downloadAppGooglePlay: function() {
            window.dataLayer.push({ event: 'download_app_google_play' });
        },
        // Download App Apple Store
        downloadAppAppleStore: function() {
            window.dataLayer.push({ event: 'download_app_apple_store' });
        },
        // Product Video Swipe
        productVideoSwipe: function(obj) {
            if (!validateFields(obj, [
                { name: 'swipe_direction', type: 'string' },
                { name: 'image_position', type: 'number' },
                { name: 'product_title', type: 'string' }
            ], 'productVideoSwipe')) return;
            window.dataLayer.push({ event: 'product_video_swipe', ...obj });
        },
        // Download Now Banner Click
        downloadNowBannerClick: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' },
                { name: 'banner_title', type: 'string' }
            ], 'downloadNowBannerClick')) return;
            window.dataLayer.push({ event: 'download_now_banner_click', ...obj });
        },
        // Claim Now Overnight Book
        claimNowOvernightBook: function() {
            window.dataLayer.push({ event: 'claim_now_overnight_book' });
        },
        // Submit Form Overnight Book
        submitFormOvernightBook: function() {
            window.dataLayer.push({ event: 'submit_form_overnight_book' });
        },
        // Gratitude Section Interactions
        gratitudeSectionInteractions: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' }
            ], 'gratitudeSectionInteractions')) return;
            window.dataLayer.push({ event: 'gratitude_section_interactions', ...obj });
        },
        // Product Video Story Open
        productVideoStoryOpen: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'product_title', type: 'string' }
            ], 'productVideoStoryOpen')) return;
            window.dataLayer.push({ event: 'product_video_story_open', ...obj });
        },
        // Product Video Story Swipe
        productVideoStorySwipe: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'product_title', type: 'string' }
            ], 'productVideoStorySwipe')) return;
            window.dataLayer.push({ event: 'product_video_story_swipe', ...obj });
        },
        // Product Video Tile Open
        productVideoTileOpen: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'product_title', type: 'string' }
            // ], 'productVideoTileOpen')) return;
            window.dataLayer.push({ event: 'product_video_tile_open', ...obj });
        },
        // Product Video Tile Swipe
        productVideoTileSwipe: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'product_title', type: 'string' },
            //     { name: 'swipe_direction', type: 'string' }
            // ], 'productVideoTileSwipe')) return;
            
            window.dataLayer.push({ event: 'product_video_tile_swipe', ...obj });
        },
        // Product Video Tile Like
        productVideoTileLike: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'product_title', type: 'string' }
            ], 'productVideoTileLike')) return;
            window.dataLayer.push({ event: 'product_video_tile_like', ...obj });
        },
        // Product Video Tile Share
        productVideoTileShare: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'product_title', type: 'string' }
            // ], 'productVideoTileShare')) return;
            window.dataLayer.push({ event: 'product_video_tile_share', ...obj });
        },
        // Product Video Tile Minimize
        productVideoTileMinimize: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'click_text', type: 'string' },
            //     { name: 'product_title', type: 'string' }
            // ], 'productVideoTileMinimize')) return;
            window.dataLayer.push({ event: 'product_video_tile_minimize', ...obj });
        },
        // Apply Coupon
        applyCoupon: function(obj) {
            if (!validateFields(obj, [
                { name: 'cart_value', type: 'number' },
                { name: 'user_id', type: 'string' },
                { name: 'discounted_cart_value', type: 'number' }
            ], 'applyCoupon')) return;
            window.dataLayer.push({ event: 'apply_coupon', ...obj });
        },
        // Remove Coupon
        removeCoupon: function(obj) {
            if (!validateFields(obj, [
                { name: 'cart_value', type: 'number' },
                { name: 'user_id', type: 'string' },
                { name: 'discounted_cart_value', type: 'number' }
            ], 'removeCoupon')) return;
            window.dataLayer.push({ event: 'remove_coupon', ...obj });
        },
        // Product Image Thumbnail Click
        productImageThumbnailClick: function(obj) {
            // if (!validateFields(obj, [
            //     { name: 'image_position', type: 'number' },
            //     { name: 'product_title', type: 'string' }
            // ], 'productImageThumbnailClick')) return;
            window.dataLayer.push({ event: 'product_image_thumnail_click', ...obj });
        },
        // Products In Bundle
        productsInBundle: function(obj) {
            if (!validateFields(obj, [
                { name: 'action_type', type: 'string' },
                { name: 'product_title', type: 'string' }
            ], 'productsInBundle')) return;
            window.dataLayer.push({ event: 'products_in_bundle', ...obj });
        },
        // Product Detail Navigation
        productDetailNavigation: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'page_section', type: 'string' }
            ], 'productDetailNavigation')) return;
            window.dataLayer.push({ event: 'product_detail_navigation', ...obj });
        },
        // Product Detail Card Swipe
        productDetailCardSwipe: function(obj) {
            if (!validateFields(obj, [
                { name: 'page_section', type: 'string' },
                { name: 'swipe_direction', type: 'string' },
                { name: 'card_position', type: 'number' }
            ], 'productDetailCardSwipe')) return;
            window.dataLayer.push({ event: 'product_detail_card_swipe', ...obj });
        },
        // Banner View
        bannerView: function(obj) {
            if (!validateFields(obj, [
                { name: 'click_text', type: 'string' },
                { name: 'click_url', type: 'string' },
                { name: 'page_section', type: 'string' },
                { name: 'banner_title', type: 'string' }
            ], 'bannerView')) return;
            window.dataLayer.push({ event: 'banner_view', ...obj });
        }
        // Add more event helpers as needed
    };
})();












